module.exports = __webpack_public_path__ + "img/menu-dot-white.294dd07d.svg";